/**
 * Constantes del contrato sin dependencias: las importa el widget (que no debe cargar zod en webs
 * ajenas) y las usan los esquemas de `schemas.ts`.
 */

/** Tamaños máximos: nada de lo que llega del widget (código público, en webs ajenas) puede pasar de aquí. */
export const LIMITS = {
  description: 5000,
  comment: 5000,
  resolution: 2000,
  selector: 1000,
  text: 500,
  html: 2000,
  url: 2000,
  attributes: 20,
  consoleEntries: 30,
  consoleMessage: 1000,
  networkEntries: 20,
  trailEntries: 20,
  screenshotBytes: 3 * 1024 * 1024,
} as const;

export const FEEDBACK_STATUSES = ["open", "in_progress", "resolved", "wont_fix", "duplicate"] as const;
export const FEEDBACK_TYPES = ["change", "bug", "content", "question", "idea"] as const;
export const SCREENSHOT_TYPES = ["image/webp", "image/jpeg", "image/png"] as const;
export const AUTHOR_TYPES = ["member", "reporter", "agent"] as const;
/**
 * Papel de una persona en una organización: owner (todo, también el equipo y otros owners), admin
 * (proyectos, tokens, integraciones y equipo) y member (trabaja las notas).
 */
/** "guest" (invitado): solo los proyectos que se le den; sin la administración de la organización. */
export const ROLES = ["owner", "admin", "member", "guest"] as const;
/** Prioridad que propone la clasificación automática. */
export const PRIORITIES = ["high", "medium", "low"] as const;

/**
 * Cómo aparece el widget en la web, de más a menos visible: barra de revisión (abajo), botón con texto, botón
 * redondo, pestaña lateral u oculto (se abre con Alt+Shift+A o con `Anota.open()` desde un botón propio).
 */
export const LAUNCHER_STYLES = ["bar", "button", "icon", "tab", "hidden"] as const;
export type LauncherStyle = (typeof LAUNCHER_STYLES)[number];

/**
 * Quién ve el widget en las webs del proyecto: cualquiera que entre ("public") o solo quien llegue con un
 * enlace de revisión ("review": `https://web/?anota=rv_…`). En "review" el servidor también exige el enlace.
 */
export const ACCESS_MODES = ["public", "review"] as const;
export type AccessMode = (typeof ACCESS_MODES)[number];

/** Token de un enlace de revisión (va en la URL que se manda al cliente). */
export const REVIEW_TOKEN_RE = /^rv_[A-Za-z0-9]{32}$/;

/** Clave «mis notas» de un navegador en un proyecto: su enlace al portal (`/portal#mis=mn_…`) para verlas en otro dispositivo. */
export const MINE_KEY_RE = /^mn_[A-Za-z0-9]{24}$/;
